/**
 * Elbox
 * - used in Charleroi
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Elbox extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'elbox',
        x: 0,
        y: 0,
        width: 60,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Line({
        name: 'strikeRight',
        points: [0, 0, 60, 30],
        stroke: 'black',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: true
      }),

      new Ren.Line({
        name: 'strikeLeft',
        points: [60, 0, 0, 30],
        stroke: 'black',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: true
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)
  }
}
